import { Building2 } from "lucide-react";

const DeveloperInfo = ({ property }) => {
  const builderName = property?.property?.builderName;
  const projectName = property?.property?.projectName;

  if (!builderName && !projectName) return null;

  return (
    <div className="border bg-white rounded-lg border-gray-200 p-4  shadow-sm">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
          <Building2 className="w-6 h-6 text-blue-600" />
        </div>
        <div className="min-w-0">
          {builderName && (
            <p className="font-semibold text-gray-900 text-sm">{builderName}</p>
          )}
          {projectName && (
            <p className="text-sm text-gray-600">{projectName}</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default DeveloperInfo;
